const mixpanel = require('mixpanel-browser');

const url = new URL(window.location);
const isProduction = url.hostname === 'mamari.jp';
const MixpanelToken = isProduction ? 'cab470d729c77d7de35b1164cddc95c5' : 'a383d328c1acb4537d2538492e9a46ea';
mixpanel.init(MixpanelToken);

const traceParentsInDomTree = (element) => {
  const elements = [];
  while (element instanceof HTMLElement) {
    elements.push(element);
    element = element.parentNode;
  }
  return elements;
};
const getTagName = (element) => element instanceof HTMLElement ? element.tagName.toLowerCase() : 'unknown';
const isNotEmptyString = (target) => typeof target === 'string' && target.trim() !== '';

window.addEventListener('click', (event) => {
  const elements = traceParentsInDomTree(event.target);
  const isApp = window.App.me.is_mamariq_app;
  const userId = window.App.me.MamariqUser != null ? window.App.me.MamariqUser.id : null;

  // Google Analytics
  const forGoogleAnalyticsTrackingElement = elements.find((element) => {
    const tagName = getTagName(element);
    return (tagName === 'a' || tagName === 'button') && isNotEmptyString(element.dataset.click);
  });
  if (forGoogleAnalyticsTrackingElement != null) {
    // https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#eventCategory
    const category = 'ClickIn' + App.vars.page_type;
    const attrData = forGoogleAnalyticsTrackingElement.dataset.click.split('|');
    const action = attrData[0] || 'UndefinedAction';
    const label = attrData[1] || 'UndefinedLabel';
    const value = 0;
    ga('send', 'event', category, action, label, value);
  }

  // Mixpanel (アプリのみ)
  if (isApp && userId != null) {
    const trackingArticleLinkItemClickElement = elements.find((element) => {
      return getTagName(element) === 'a' &&
        isNotEmptyString(element.dataset.link_type_for_mixpanel) &&
        isNotEmptyString(element.href);
    });
    if (trackingArticleLinkItemClickElement != null) {
      mixpanel.identify(userId);
      mixpanel.track('ArticleLinkItemClick', {
        // 文字は 255bytes の制限があるが、検証した結果自動で切り取られる（送られないわけではない）ので特に何も対応しない
        // https://github.com/Connehito/kenkolab/issues/7204#issuecomment-1165155612
        LinkText: trackingArticleLinkItemClickElement.textContent.trim() || '(Empty)',
        LinkURL: trackingArticleLinkItemClickElement.href,
        LinkType: trackingArticleLinkItemClickElement.dataset.link_type_for_mixpanel,
      });
    }
  }
});




// WEBPACK FOOTER //
// ./tracking.js